import { render } from "./SaleModal.vue?vue&type=template&id=2ed26715&scoped=true"
import script from "./SaleModal.vue?vue&type=script&lang=js"
export * from "./SaleModal.vue?vue&type=script&lang=js"

import "./SaleModal.vue?vue&type=style&index=0&id=2ed26715&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed26715"]])

export default __exports__